"use client";

import { useEffect } from "react";

/**
 * Mounted once inside the Home page. Watches every element carrying
 * the `home-reveal` or `home-stagger` class and adds `is-visible`
 * once it scrolls into view — globals.css does the actual fade/
 * slide-up transition. Mirrors app/about/AboutReveal.tsx.
 */
export default function HomeReveal() {
  useEffect(() => {
    const els = Array.from(
      document.querySelectorAll<HTMLElement>(".home-reveal, .home-stagger")
    );
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return null;
}
